export default "__VITE_ASSET__3575fac0__"